import {
  createContext,
  type PropsWithChildren,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react"
import { useWindowSize } from "usehooks-ts"

type SidemenuContextType = {
  isOpen: boolean
  handler: {
    open: () => void
    close: () => void
  }
}

export const SidemenuContext = createContext({} as SidemenuContextType)

export function SidemenuProvider({ children }: PropsWithChildren) {
  const [isOpen, setIsOpen] = useState<boolean>(true)
  const { width } = useWindowSize()

  const open = useCallback(() => setIsOpen(true), [])
  const close = useCallback(() => setIsOpen(false), [])

  const handler = useMemo(() => ({ open, close }), [open, close])

  const value = useMemo(() => ({ isOpen, handler }), [isOpen, handler])

  useEffect(() => {
    if (width < 1280) {
      close()
    } else {
      open()
    }
  }, [width])

  return (
    <SidemenuContext.Provider value={value}>
      {children}
    </SidemenuContext.Provider>
  )
}
